'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.SearchCriteria', 'AVRO.Common.Moment', 'AVRO.Common.Formatting'];
module.exports = angular.module('AVRO.Common.SearchSummary', dependencies).directive('rmSearchSummary', require('./directives/SearchSummaryDirective')).controller('SearchSummaryController', require('./controllers/SearchSummaryController')).factory('SearchSummaryService', require('./services/SearchSummaryService'));